import { Stack } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import BreadCrumbs from 'app/crumbs/BreadCrumbs'

interface Props {
  title: string
  titlePrefix?: JSX.Element
  titleSuffix?: JSX.Element
}

export const PageHeader: React.FC<Props> = ({ title, titlePrefix, titleSuffix }) => {
  return (
    <Stack direction='row' alignItems='center'>
      {titlePrefix}
      <Typography
        variant='h6'
        sx={{
          textOverflow: 'ellipsis',
          lineHeight: 1
        }}
      >
        {title}
      </Typography>
      {titleSuffix}
      <Box
        sx={{
          borderLeft: '2px solid black',
          borderColor: 'rgba(0,0,0,.2)',
          pl: 1.5,
          ml: 1.5
        }}
      >
        <BreadCrumbs />
      </Box>
    </Stack>
  )
}
export default PageHeader
